export { default as VictoryBoxPlot } from "./victory-box-plot";